module.exports = __webpack_public_path__ + "static/media/auto-background.66f702bd.svg";